export function filterUserByNameOrEmail(
  row: { name?: string | null; email?: string | null },
  text: string,
): boolean {
  const filter = (text || "").toLowerCase();
  return (
    row.name?.toLowerCase().includes(filter) ||
    row.email?.toLowerCase().includes(filter) ||
    false
  );
}
